import { gql, useMutation } from '@apollo/client';
import { AnyObject } from '../../../models/types';

export interface ExecuteCommandVars {
  url: string;
  args: AnyObject;
  approval?: JSON;
  confirm?: JSON;
}

export const EXECUTE_INSTANCE_COMMAND = gql`
    mutation ExecuteCommand($url: String!, $args: JSON, $approval: JSON, $confirm: JSON, $piezoArtifacts: JSON) {
        executeCommand(
            url: $url
            args: $args
            approval: $approval
            confirm: $confirm
            piezoArtifacts: $piezoArtifacts
        )
    }
`;

export const useExecuteCommandMutation = () => {
  return useMutation<AnyObject, ExecuteCommandVars>(EXECUTE_INSTANCE_COMMAND);
};
